var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-with-footer',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('page-header',{staticClass:"default-gutter mb-6"}),_c('page-breadcrumbs'),_c('contact-us-container')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }